export const EASE_OUT_BACK = 'cubic-bezier(0.34, 1.56, 0.64, 1)';
export const EASE_IN_BACK = 'cubic-bezier(0.36, 0, 0.66, -0.56)';
export const EASE_IN_OUT_BACK = 'cubic-bezier(0.68, -0.6, 0.32, 1.6)';
